/**
 * mwApp.subscribers module <br>
 * Work with subscribers: show/add/edit/remove
 *
 * @namespace mwApp/subscribers
 */

import ActivationCreditCardsCtrl from './activation/creditCards.controller'
import ActivationCtrl from './activation/activation.controller'
import ActivationDevicesCtrl from './activation/devices.controller'
import ActivationPaymentsAddDeviceCtrl from './activation/paymentsAddDevice.controller'
import ActivationPaymentsCommonSubscriptionCtrl from './activation/paymentsCommonSubscription.controller'
import ActivationPaymentsCtrl from './activation/payments.controller'
import ActivationPaymentsCustomChargeCtrl from './activation/paymentsCustomCharge.controller'
import ActivationPaymentsCustomSubscriptionCtrl from './activation/paymentsCustomSubscription.controller'
import ActivationPaymentsMiscCtrl from './activation/paymentsMisc.controller'
import ActivationStatementsCtrl from './activation/statements.controller'
import AddCreditCardCtrl from './activation/addCreditCard.controller'
import AddNoteCtrl from './addNote.controller'
import AddPaymentStatementCommentCtrl from './activation/addPaymentStatementComment.controller'
import AddSubscriberCtrl from './addSubscriber.controller'
import AssignDevicesCtrl from './assignDevice.controller'
import CustomStreamsCtrl from './customStreams.controller'
import NotesCtrl from './notes.controller'
import SubscribersCtrl from './subscribers.controller'
import {
  maxDays,
  cardStatus,
  bindScopeToView,
  contentName,
  contentNameSearchPlaceholder
} from './subscribers.directives'
import subscribersConfig from './subscribers.config'
import AssignStreamsCtrl from './assignStreams.controller'
import ChangePackageCtrl from './changePackage.controller'
import AdjustSubscriptionCtrl from './activation/adjustSubscription.controller'
import ShowConflictsCtrl from './activation/showConflicts.controller'
import AddContentAddonsCtrl from './activation/addContentAddons.controller'
import ActivationPaymentsContentAddonsCtrl from './activation/paymentsContentAddons.controller'
import AdjustAddonsCtrl from './activation/adjustAddons.controller'
import NoteUpdatesCtrl from './noteUpdates.controller'
import EditAccessoryNoteCtrl from './editAccessoryNote.controller'
import ActivationLibraryCtrl from './activation/library.controller'
import ActivationLibraryContentCtrl from './activation/libraryContent.controller'
import DiscountDetailsModalCtrl from './activation/modals/discountDetailsModal.controller'
import PurchaseCommentHistoriesModalCtrl from './activation/modals/purchaseCommentHistoriesModal.controller'

export default
angular.module('mwApp.subscribers', [])
  .config(subscribersConfig)
  .directive('maxDays', maxDays)
  .directive('cardStatus', cardStatus)
  .directive('bindScopeToView', bindScopeToView)
  .directive('contentName', contentName)
  .directive('contentNameSearchPlaceholder', contentNameSearchPlaceholder)
  .controller('SubscribersCtrl', SubscribersCtrl)
  .controller('AddSubscriberCtrl', AddSubscriberCtrl)
  .controller('CustomStreamsCtrl', CustomStreamsCtrl)
  .controller('AssignStreamsCtrl', AssignStreamsCtrl)
  .controller('ChangePackageCtrl', ChangePackageCtrl)
  .controller('NotesCtrl', NotesCtrl)
  .controller('AddNoteCtrl', AddNoteCtrl)
  .controller('EditAccessoryNoteCtrl', EditAccessoryNoteCtrl)
  .controller('NoteUpdatesCtrl', NoteUpdatesCtrl)
  .controller('ActivationCtrl', ActivationCtrl)
  .controller('ActivationCreditCardsCtrl', ActivationCreditCardsCtrl)
  .controller('ActivationDevicesCtrl', ActivationDevicesCtrl)
  .controller('AssignDevicesCtrl', AssignDevicesCtrl)
  .controller('ActivationPaymentsCtrl', ActivationPaymentsCtrl)
  .controller('ActivationPaymentsAddDeviceCtrl', ActivationPaymentsAddDeviceCtrl)
  .controller('ActivationPaymentsCommonSubscriptionCtrl', ActivationPaymentsCommonSubscriptionCtrl)
  .controller('ActivationPaymentsCustomChargeCtrl', ActivationPaymentsCustomChargeCtrl)
  .controller('ActivationPaymentsCustomSubscriptionCtrl', ActivationPaymentsCustomSubscriptionCtrl)
  .controller('ActivationPaymentsMiscCtrl', ActivationPaymentsMiscCtrl)
  .controller('ActivationStatementsCtrl', ActivationStatementsCtrl)
  .controller('AddCreditCardCtrl', AddCreditCardCtrl)
  .controller('AddPaymentStatementCommentCtrl', AddPaymentStatementCommentCtrl)
  .controller('DiscountDetailsModalCtrl', DiscountDetailsModalCtrl)
  .controller('PurchaseCommentHistoriesModalCtrl', PurchaseCommentHistoriesModalCtrl)
  .controller('AdjustSubscriptionCtrl', AdjustSubscriptionCtrl)
  .controller('AdjustAddonsCtrl', AdjustAddonsCtrl)
  .controller('ShowConflictsCtrl', ShowConflictsCtrl)
  .controller('AddContentAddonsCtrl', AddContentAddonsCtrl)
  .controller('ActivationPaymentsContentAddonsCtrl', ActivationPaymentsContentAddonsCtrl)
  .controller('ActivationLibraryCtrl', ActivationLibraryCtrl)
  .controller('ActivationLibraryContentCtrl', ActivationLibraryContentCtrl)
